import { ReactNode, useEffect } from 'react';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-3567LR0VXR');

export function Container(props: { children: ReactNode }) {
  useEffect(() => {
    function listen(event: any) {
      
      const target = event.target.closest(
        'div[data-action],a[data-action],button[data-action],li[data-action]'
      );

      if (!target) {
        return;
      }

      const action = target.dataset.action;
      const label = target.dataset.label;
      const category = target.dataset.category;

      if (!action) {
        return;
      }

      ReactGA.event({
        category: category || 'action',
        action: action,
        label: label,
      });
    }

    document.addEventListener('click', listen);

    return () => document.removeEventListener('click', listen);
  }, []);

  return props.children;
}
